/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */const o=(t,...e)=>({strTag:!0,strings:t,values:e}),c=o,a=t=>typeof t!="string"&&"strTag"in t,g=(t,e,s)=>{let n=t[0];for(let r=1;r<t.length;r++)n+=e[r-1],n+=t[r];return n};export{a as isStrTagged,g as joinStringsAndValues,c as str};
